import React, {useContext, useState, useEffect} from 'react'
import { Button, Divider, Menu, Select, Tooltip, message } from 'antd';
import { appContext } from "../../AppContext";
import { HomeOutlined, DatabaseOutlined, SettingOutlined, UserOutlined, CameraOutlined, CalendarOutlined } from '@ant-design/icons';
import {
  Link,
} from 'react-router-dom';
import {useFetch} from './../../utils/hooks/useFetch'
import {
  Mobile,
  DefaultDevice
} from '../../utils/mediaQuery'
const { Option } = Select;

export default function LarpTOMMenu() {

  const [stories, setStories] = useState([]);
  const [appState, AppDispatch] = useContext(appContext)
  const [doFetch, FetchOptions] = useFetch();

  useEffect(() => {
    if(appState.user !== undefined) {
      doFetch("/api/Story/GetAllStories")
        .then((response) => storiesLoaded(response.isSuccess, response.result))

        function storiesLoaded(isSuccess, result) {
          if(isSuccess) {
            setStories(result);
            AppDispatch({ type: "SETSTORIES", payload: result})
          }
        }
      }
  }, // eslint-disable-next-line
  [])

  useEffect(() => {

    if(stories.length === 0) {
      return;
    }
    
    if(appState.storyId === -1)
    {
      handleChangeSelectStory(stories[0]?.id)
    }

  },     //eslint-disable-next-line
  [stories])

  function handleChangeSelectStory(value) {

    const selectedStory = stories.find(story => story.id === value)
    AppDispatch({ type: "SETSTORYID", payload: {storyId:value, storyName:selectedStory.name} })
    localStorage.setItem('LarpTOM.StoryId', value);
    localStorage.setItem('LarpTOM.StoryName', selectedStory.name);
  }

  const storyOptions = stories.map(story => {
    if((story.name === "Zivania" || story.name === "Zomerlarp")  && !appState.user.isAdmin) {
      return null;
    }
      return (<Option 
        value={story.id} 
        key={story.id}
      >
        {story.name}
      </Option>)
    })

    function logOut() {

      const url = `/api/Account/LogOut`;
      doFetch(url)
      .then((response) => {
        if(response.result.status === 200) {
              AppDispatch({ type: "LOGOUT" })
              return;
          }
          message.error('LogOut failed')
      })
    }


    return (
      <>
      <Mobile>
        {/* do something else */}
        <div className="menu-container">

        <Menu mode="horizontal">

          <Menu.Item icon={<UserOutlined />} key="5">
            <Link to={`/${appState.appName}/Character-builder`}>Character builder</Link>
          </Menu.Item>

          <Menu.Item icon={<DatabaseOutlined />} key="8">
            <Link to={`/${appState.appName}/wiki`}>Wiki</Link>
          </Menu.Item>

           
            {appState.isAnSl && 
              <Menu.Item key="15">
            <Button onClick={() => window.location.href=appState.slUrl}>SL Mode</Button>     
          </Menu.Item>}
        



        <Menu.Item icon={<CalendarOutlined />} key="registrations">
              <Link Link to={`/${appState.appName}/registration`}>Registration</Link>
            </Menu.Item>

        <Menu.Item icon={<SettingOutlined />} key="2">
          <Link to={`/${appState.appName}/profile`}>Profile</Link>     
        </Menu.Item>

        <Menu.Item icon={<CameraOutlined />} key="7">
            <Link to={`/${appState.appName}/photos`}>Photos</Link>     
          </Menu.Item>

          <Menu.Item icon={<HomeOutlined />} key="1">
            <Link to={`/${appState.appName}/`}>Home</Link>
          </Menu.Item>

        </Menu>
</div>
        
      </Mobile>

      <DefaultDevice>
      <div className="menu-container">
      
      <Menu
        style={{ color:"#0C4a00", background:"white"}}
        mode="inline"
        inlineCollapsed={false}
      >    
      <div className="menu-img-container">   
        <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt="Logo" /> 
      </div>
      
          <Menu.Item icon={<HomeOutlined />} key="1">
            <Link to={`/${appState.appName}/`}>Home</Link>
          </Menu.Item>

          <Menu.Item icon={<CalendarOutlined />} key="registrations">
            <Link Link to={`/${appState.appName}/registration`}>Registration</Link>
          </Menu.Item>

          <Menu.Item icon={<CameraOutlined />} key="7">
            <Link to={`/${appState.appName}/photos`}>Photos</Link>     
          </Menu.Item>

          <Divider />

          <div className="menu-selectbox-container">
            {appState.selectedPage === 'Character' ?
              <Tooltip title="You can't change the story if you are looking at a character">
                <Select 
                    onChange={handleChangeSelectStory}
                    value={parseInt(appState.storyId)}
                    className="menu-selectbox"
                    disabled={appState.selectedPage === 'Character'}
                    >
                        {storyOptions} 
                </Select>
              </Tooltip> 
              : 
              <Select 
                    onChange={handleChangeSelectStory}
                    value={parseInt(appState.storyId)}
                    className="menu-selectbox"
                    disabled={appState.selectedPage === 'Character'}
                    >
                        {storyOptions} 
                </Select>}
          </div>

          <Menu.Item icon={<UserOutlined />} key="5">
            <Link to={`/${appState.appName}/Character-builder`}>Character builder</Link>
          </Menu.Item>

          
          <Menu.Item icon={<DatabaseOutlined />} key="13">
            <Link to={`/${appState.appName}/wiki`}>Wiki</Link>
          </Menu.Item>

          <Divider />


      <Menu.Item icon={<SettingOutlined />} key="2">
        <Link to={`/${appState.appName}/profile`}>Profile</Link>     
      </Menu.Item>

      {appState.isAnSl && 
              <Menu.Item key="15">
            <Button href={appState.slUrl}>SL Mode</Button>     
          </Menu.Item>}

      {appState.user !== undefined && 
          <Menu.Item key="16">
              <Button onClick={logOut}>Logout</Button>
          </Menu.Item>}

      </Menu>
      </div>
      </DefaultDevice>
      </>
    )
}